export const BANKDATA_LOADING = "BANKDATA_LOADING";
export const GET_BANKDATA = "GET_BANKDATA";
export const GET_BANKDATA_SUCCESS = "GET_BANKDATA_SUCCESS";
export const GET_BANKDATA_FAIL = "GET_BANKDATA_FAIL";
export const DELETE_BANKDATA = "DELETE_BANKDATA"
export const DELETE_BANKDATA_SUCCESS = "DELETE_BANKDATA_SUCCESS"
export const DELETE_BANKDATA_FAIL = "DELETE_BANKDATA_FAIL"
export const UPDATE_BANKDATA = "UPDATE_BANKDATA"
export const UPDATE_BANKDATA_SUCCESS = "UPDATE_BANKDATA_SUCCESS"
export const UPDATE_BANKDATA_FAIL = "UPDATE_BANKDATA_FAIL"
export const ADD_NEW_BANKDATA = "ADD_NEW_BANKDATA"
export const ADD_BANKDATA_SUCCESS = "ADD_BANKDATA_SUCCESS"
export const ADD_BANKDATA_FAIL = "ADD_BANKDATA_FAIL"